export default __webpack_public_path__ + "static/media/icon3.1dad84c2.svg";